import React, { useMemo } from "react";
import { Autocomplete, Skeleton, TextField, Checkbox } from "@mui/material";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { useDistributorsContext } from "../Contexts/distributorsContext";
import { useFulfillmentStatusContext } from "../Contexts/fulfillmentStatusContext";

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;

export default function DivisionMultiSelection() {
    const { distributors, isReady: areDistributorsReady } = useDistributorsContext();
    const { selectedDivisions, setSelectedDivisions } = useFulfillmentStatusContext();

    const divisionOptions = useMemo(() => {
        if (!distributors) {
            return [];
        }

        return [...new Set(distributors
            .map((distributor) => distributor.division?.trim())
            .filter((division) => !!division))]
            .sort((left, right) => left.localeCompare(right));
    }, [distributors]);

    if (!areDistributorsReady) {
        return (
            <div>
                <Skeleton variant="rectangular" width={250} height={50} />
            </div>
        );
    }

    return (
        <Autocomplete
            multiple
            limitTags={1}
            disablePortal
            id="combo-box-division"
            options={divisionOptions}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
                <li {...props} key={option}>
                    <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                    />
                    {option}
                </li>
            )}
            sx={{ width: 250 }}
            renderInput={(params) => (
                <TextField {...params} label="Select Divisions" />
            )}
            value={selectedDivisions || []}
            onChange={(event, value) => {
                setSelectedDivisions(value);
            }}
        />
    );
}
